module.exports = __webpack_public_path__ + "static/hero-427e957622b82f756d4ec7c0b6c305a0.jpg";